import brandColors from "style/color/brandColor";

const myrealtrip = {
  fonts: {
    main: "애플 SD 산돌고딕 Neo, Apple SD Gothic Neo, NanumSquare, sans-serif",
    number: "Rubik"
  },
  media: {
    min: "960px",
    max: "2560px"
  },
  weight: {
    light: 300,
    normal: 400,
    bold: 600,
    bolder: 700,
    extraBold: 700
  },
  radius: "5px",
  colors: {
    primary: brandColors.primaryPC,
    secondary: brandColors.secondary,
    white: brandColors.white,
    text: brandColors.gray12,
    textSub: brandColors.gray10,
    textType: "",
    inputBorder: "",
    divider: brandColors.gray8,
    divider2: "",
    divider3: "",
    planText: "",
    productInfo: "",
    footerDivider: brandColors.gray10,
    bg: brandColors.gray9,
    border: brandColors.gray8,
    dash: brandColors.gray11
  },
  buttonPrimary: {
    colorBg: "",
    colorFont: "",
    sizeFont: ""
  },
  buttonSmall: {
    colorFont: "",
    colorBorder: "",
    sizeFont: ""
  },
  buttonText: {
    colorFont: brandColors.gray3,
    colorFontDark: brandColors.gray10,
    sizeFontM: "13px",
    sizeFont: "12px"
  },
  button: {
    colorLine: brandColors.gray3,
    colorFont: brandColors.gray12,
    sizeFont: "12px"
  },
  buttonRound: {
    sizeFont: "16px"
  },
  popup: {
    sizeFont: "13px",
    sizeHeader: "16px",
    sizeDesc: "12px",
    sizeButton: "",
    colorDesc: brandColors.gray10,
    colorFont: ""
  },
  popupBottom: {
    sizeHeader: "16px",
    colorFont: brandColors.gray6
  },
  guidePopup: {
    sizeTitle: "24px",
    colorPermission: brandColors.gray4
  },
  label: {
    sizeFont: "12px",
    colorFont: ""
  },
  placeholder: {
    colorFont: brandColors.gray10,
    sizeFont: ""
  },
  input: {
    colorBorder: brandColors.gray8,
    colorFont: "",
    sizeFont: ""
  },
  selectBox: {
    colorBorder: brandColors.gray8,
    colorFont: "",
    colorBg: brandColors.gray9
  },
  footer: {
    colorBg: brandColors.gray9,
    colorFont: brandColors.gray10,
    colorTell: brandColors.gray12,
    sizeFont: "12px"
  },
  title: {
    sizeFont: "16px",
    sizeFontL: "20px"
  },
  text: {
    colorFont: brandColors.gray10,
    colorFont2: brandColors.gray3,
    colorFont3: brandColors.gray12,
    colorDisabled: brandColors.gray4,
    sizeFontL: "16px",
    sizeFontM: "14px",
    sizeFontS: "13px",
    sizeFont: "12px",
    sizeFontXS: "11px",
    sizeFontXXS: "10px"
  },
  calendar: {
    colorDisabled: brandColors.gray4,
    colorFont: brandColors.gray12,
    colorToday: brandColors.gray9,
    sizeFont: "15px",
    sizeHeader: "18px",

    // old
    font: "14px",
    headerFont: "18px",
    disabledColor: brandColors.gray6,
    headerColor: brandColors.gray12
  },
  loading: {
    sizeFont: "18px",
    colorFont: ""
  },
  table: {
    colorBorder: brandColors.gray11,
    colorBorderInner: brandColors.gray8
  },
  travel: {
    sizeFont: "20px"
  },
  country: {
    colorFont: brandColors.gray3,
    colorLine: brandColors.gray8,
    sizeFont: "13px"
  },
  search: {
    colorBg: brandColors.gray9,
    colorResult: brandColors.gray11,
    colorLine: brandColors.gray8,
    colorDisabled: brandColors.gray4,
    sizeFont: "14px"
  },
  tooltip: {
    colorBg: brandColors.gray12
  }
};

export default myrealtrip;
